import { render, staticRenderFns } from "./DataTableReports.vue?vue&type=template&id=57f67677&scoped=true"
import script from "./DataTableReports.vue?vue&type=script&lang=js"
export * from "./DataTableReports.vue?vue&type=script&lang=js"
import style0 from "./DataTableReports.vue?vue&type=style&index=0&id=57f67677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f67677",
  null
  
)

export default component.exports